import * as core from '../../../../../../../core'

import { query } from './award.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.award',
    description: 'Subaward Award',
    name: 'Subaward Award',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
